import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChatStateService } from 'src/app/services/chat-state.service';
import { CoreaiService } from 'src/app/services/coreai.service';
import { DateCategorizerService } from 'src/app/services/date-categorizer.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BotService } from 'src/app/services/bot-service';
import { RouterService } from 'src/app/services/router.service';
import { ChatGptService } from 'src/app/services/chat-gpt.service';
import { ToastMessageService } from 'src/app/services/toast-message.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-chat-history',
  templateUrl: './chat-history.component.html',
  styleUrls: ['./chat-history.component.scss']
})
export class ChatHistoryComponent implements OnInit, OnDestroy {
  chatHistoryList: any = [];
  groupedList: any = [];
  isLoading = false;
  private routerSubscription!: Subscription;
  subChatHistoryUpdate!: Subscription;
  @ViewChild('deleteModel', { static: true }) deleteModel!: TemplateRef<any>;
  deleteHistory: any;
  oldRoute:any;
  constructor(
    private chatStateService: ChatStateService,
    private botService: BotService,
    private coreAIService: CoreaiService,
    private dateCategorizerService: DateCategorizerService,
    private router: Router,
    private chatGptService: ChatGptService,
    private toastMessageService: ToastMessageService,
    private modalService: NgbModal,
    private loaderService:LoaderService,
    private routerService:RouterService
  ) {

    this.subChatHistoryUpdate = this.chatStateService.chatHistroyUpdate.subscribe((res: any) => {
      if (res) {
        //console.log("Change in history", res);

        // Categorize the new history item
        const categorizedItem = {
          ...res,
          type: this.dateCategorizerService.categorizeDate(res.timestamp)
        };

        // Check if "Today" category exists
        let todayCategory = this.chatHistoryList.find((item: any) => item.type === 'Today');
        if (!todayCategory) {
          // If "Today" category does not exist, create it
          todayCategory = { type: 'Today', data: [] };
          this.chatHistoryList.unshift(todayCategory);
        }

        // Add the categorized item to the appropriate category
        todayCategory.data.unshift(categorizedItem);

        // Sort the chat history list
        this.chatHistoryList = this.dateCategorizerService.sortGroupedDataByType(this.chatHistoryList);
      }
    });

  }

  ngOnInit(): void {
    this.loadChatHistory();

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentRoute = event.urlAfterRedirects;       

        if(this.oldRoute == currentRoute){
          this.oldRoute = currentRoute;
          return;
        }

        if(this.oldRoute === '/work' && currentRoute.startsWith('/work/')){
          this.loadChatHistory();
          console.log('work bot')
          this.oldRoute = currentRoute;
          return;
        }      

        if ((this.oldRoute === "/" && currentRoute === '/chat') ||
          (this.oldRoute === "/chat" && currentRoute === '/')) {
            this.loadChatHistory();
            console.log('play bot')
            this.oldRoute = currentRoute;
            return;
        }       
      }
    });

  }

  openVerticallyCentered() {
    this.modalService.open(this.deleteModel, { centered: true, modalDialogClass: 'model-custom' });
  }

  sentToInput(prompt: any) {
    this.chatStateService.inputPromptFired(false);
    if (prompt && prompt?.application === 'GenAssist') {
      const botInfo = this.botService.getBotByUrl(prompt?.application_url);
      console.log("Calling Here yaar", botInfo);
      this.router.navigate(['/work/bots/', botInfo[0]?.fragment], { queryParams: { prompt: prompt?.prompt } });
    } else {
      this.chatStateService.chatHistoryDetailState.next(prompt)
      this.router.navigate(['/chat'])
    }
  }

  //chat menu history section
  // Toggle option menu visibility
  toggleOptionsMenux(prompt: any) {
    prompt['showOptions'] = !prompt['showOptions'];
  }

  // Enable prompt editing
  editPrompt(prompt: any) {
    prompt['isEditing'] = true;
    prompt['showOptions'] = false;
    // prompt.showOptions = false; // hide the dropdown after selecting edit
  }

  // Save the edited prompt
  saveEdit(prompt: any) {
    prompt['isProcessing'] = true;
    let payload = { chat_id: prompt?.chat_id, new_title: prompt?.prompt };
    this.chatGptService.editChatTitle(payload)
      .subscribe(
        (res: any) => {
          // Remove prompt from history
          if (res?.status != 'success') {
            this.toastMessageService.showError(res?.message || 'Something went wrong!')
          }
          prompt['isProcessing'] = false;
          prompt['isEditing'] = false;
          prompt['showOptions'] = false;
        },
        (error) => {
          prompt['isProcessing'] = false;

          console.error(error);
          this.toastMessageService.showError(error?.message);
        }
      );
  }

  // Initiate delete confirmation
  deletePrompt(prompt: any, index: number) {
    // prompt['isDeleting'] = true;
    // prompt['showOptions'] = false;
    this.deleteHistory = prompt;
    this.deleteHistory['index'] = index;
    this.openVerticallyCentered()
    // prompt.showOptions = false; // hide the dropdown

  }

  // Confirm deletion
  confirmDelete() {

    // Find the prompt to delete based on chat_id
    let prompt = this.chatHistoryList[this.deleteHistory['index']]['data'].find((ele: any) => ele?.chat_id == this.deleteHistory.chat_id);
    prompt['isProcessing'] = true;

    // Dismiss all modals
    this.modalService.dismissAll();
    this.loaderService.showProgress();
    // Prepare payload for deletion request
    let payload = { chat_id: this.deleteHistory?.chat_id };

    // Call the service to delete user history
    this.chatGptService.deleteUserHistory(payload)
      .subscribe(
        (res: any) => {
          // Check if the response status is success
          if (res?.status == 'success') {
            // Iterate through chat history list to find and remove the prompt
            this.chatHistoryList.forEach((history: any) => {
              const index = history.data.indexOf(prompt);
              this.deleteHistory = null;
              if (index > -1) {
                history.data.splice(index, 1);
                // If history.data length is 0, remove the history object
                if (history.data.length == 0) {
                  const historyIndex = this.chatHistoryList.indexOf(history);
                  if (historyIndex > -1) {
                    this.chatHistoryList.splice(historyIndex, 1);
                  }
                }
              }
            });
          }
          prompt['isProcessing'] = false;
          this.loaderService.hideProgress();
        },
        (error) => {
          // Handle error scenario
          prompt['isProcessing'] = false;
          console.error(error);
          this.toastMessageService.showError(error?.message);
          this.loaderService.hideProgress();
        }
      );

  }

  //cal apis




  // load chat history


  private loadChatHistory(): void {
    console.log('dds',this.oldRoute , this.router.url.startsWith('/work/'),this.router.url)
    this.isLoading = true;
    setTimeout(() => {    

      if(this.oldRoute === '/work' || this.router.url.startsWith('/work/') || this.router.url == '/work'){
        this.getBotHistory();        
      }     

      if (( this.router.url === '/' || this.router.url === '/chat')) {
          this.getPlaygroundHistory();        
      } 
    }, 3000);
  }

  // Need to implement infinite scrolling as you scroll it should load, but needs backed support
  getPlaygroundHistoryx() {
    // this.loaderService.show();
    this.coreAIService.getPromptFilter(60).subscribe({
      next: (res: any) => {
        // console.log("History Response", res);
        //this.loaderService.hide();
        if (res?.result && res.result.length > 0) {
          this.processHistoryData(res.result);


        } else {
          this.chatHistoryList = [];
        }
        this.isLoading = false;
      },
      error: (error) => {
        //this.loaderService.hide();
        console.error('Error fetching playground history:', error);
        //this.toastMessage.showError(error?.error?.message || 'An error occurred while fetching history');
        this.chatHistoryList = [];
        this.isLoading = false;
      }
    });
  }


  getPlaygroundHistory() {
    // this.loaderService.loading.next(true);

    this.chatGptService.getUserHistory()
      .subscribe(
        (res: any) => {

          if (res?.result && res.result.length > 0) {
            this.processHistoryData(res.result);


          } else {
            this.chatHistoryList = [];
          }
          this.isLoading = false;

          // this.loaderService.loading.next(false);
          if (res) {
            // this.chatHistoryList
            let result = res.map((chat: any) => ({
              ...chat,
              prompt: chat.title,
              timestamp: new Date(chat.date).getTime(),
              date: undefined // Optionally remove the original date field
            })) || [];

            this.processHistoryData(result);
          } else {
            this.chatHistoryList = [];
          }
          this.isLoading = false;
        },
        (error) => {
          // this.loaderService.loading.next(false);
          this.isLoading = false;

          console.log(error);
          // this.toastMessage.showError(error?.error?.message);
        }
      );
  }

  getBotHistory() {
    this.coreAIService.getBotHistory(100).subscribe({
      next: (res: any) => {
        if (res?.result && res.result.length > 0) {
          this.processHistoryData(res.result);
        } else {
          this.chatHistoryList = [];
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching bot history:', error);
        this.chatHistoryList = [];
        this.isLoading = false;
      }
    });
  }

  private processHistoryData(data: any[]) {

    this.chatHistoryList = data.map(ele => ({
      ...ele,
      type: this.dateCategorizerService.categorizeDate(ele?.timestamp)
    }));

    this.chatHistoryList = this.dateCategorizerService.groupChatsByType(this.chatHistoryList);
    // console.log("Grouped Data:", this.chatHistoryList);
    this.chatHistoryList = this.dateCategorizerService.sortGroupedDataByType(this.chatHistoryList);

    // console.log("Sorted Data:", this.chatHistoryList);


  }






  ngOnDestroy(): void {
    this.subChatHistoryUpdate?.unsubscribe();
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    
  }
}
